export default __webpack_public_path__ + "static/media/contact.4b2771ca.png";